export default __webpack_public_path__ + "static/media/sayli-tawhare.2ca71cc7.jpg";